import { get, writable } from 'svelte/store';
import { CustomListService } from '../../services/custom-list.service';
export const loading = writable(false);
export const editing = writable(false);
export const records = writable([]);
export const record = writable(null);
let initialized = false;
export async function init() {
    // if (!initialized) {
    //   initialized = true;
    editing.set(false);
    records.set([]);
    record.set(null);
    loadSchemas();
    // }
}
export async function loadSchemas() {
    let data = await CustomListService.getCustomListSchemas().toPromise();
    records.set(data.payload);
}
export function onCreate() {
    let item = {
        oid: 0,
        description: '',
        regionId: 0
    };
    record.set(item);
    editing.set(true);
}
export function onEdit(item) {
    record.set(Object.assign({}, item));
    editing.set(true);
}
export async function save() {
    let _record = get(record);
    await CustomListService.saveCustomListSchema(_record).toPromise();
    await loadSchemas();
}
export async function onDelete(item) {
    await CustomListService.deleteCustomListSchema(item.oid).toPromise();
    await loadSchemas();
}
